module.exports = __webpack_public_path__ + "img/studyimg6.87cb9942.jpg";